import CryptoJS from "crypto-js"
import moment from "moment"

export const GETTING_URL = "GETTING_URL"
export const VERSION_NO = "v8_1"


export const getMeetingUrl = () => {

    if (window.location.origin === "http://localhost:4000") return "https://chimetest.myhomept.co"
    if (window.location.origin === "http://localhost:8080") return "https://chimetest.myhomept.co"
    return window.location.origin
}


export const getUrl = (isEngage) => async (dispatch, getState) => {
    CustomLogger(`${window.location.hostname} detected`)
    try {
        if (isEngage) {
            if (window.location.hostname === "localhost") {
                // dispatch({
                //     type: GETTING_URL,
                //     payload: "https://provider.somatichealth.com",
                // })
                // CustomLogger(`Using https://provider.somatichealth.com`)
                dispatch({
                    type: GETTING_URL,
                    payload: "https://www.myhomept.co",
                })
                CustomLogger(`Using https://www.myhomept.co`)
            }
            if (window.location.hostname == "chimetest.myhomept.co") {
                dispatch({
                    type: GETTING_URL,
                    payload: "https://www.myhomept.co",
                })
                CustomLogger(`Using https://www.myhomept.co`)
            }
            if (window.location.hostname == "meeting.myhomept.co") {
                dispatch({
                    type: GETTING_URL,
                    payload: "https://www.myhomept.co",
                })
                CustomLogger(`Using https://www.myhomept.co`)

            }
            if (window.location.hostname == "betameeting.myhomept.co") {
                dispatch({
                    type: GETTING_URL,
                    payload: "https://beta.myhomept.co",
                })
                CustomLogger(`Using https://beta.myhomept.co`)

            }
            if (window.location.hostname == "premeeting.somatichealth.com") {
                dispatch({
                    type: GETTING_URL,
                    payload: "https://preprovider.somatichealth.com",
                })
                CustomLogger(`Using https://preprovider.somatichealth.com`)

            }
            if (window.location.hostname == "meeting.somatichealth.com" || window.location.hostname == "meeting.bluejayhealth.com") {
                dispatch({
                    type: GETTING_URL,
                    payload: "https://provider.somatichealth.com",
                })
                CustomLogger(`Using https://provider.somatichealth.com`)

            }
        }
    } catch (error) {
        CustomLogger("Some Error Occured");
        console.log(error);

    }
}



function arc4random() {
    return Math.floor(Math.random() * 4294967296);
}

function padString(source) {
    let size = 16;
    let x = source.length % size;
    let padLength = size - x;
    let paddingChar = String.fromCharCode(128 + padLength); //+128 to avoid ASCII 7 bit char

    for (let i = 0; i < 128 + padLength; i++) source += paddingChar; //' '

    return source;
}

export const getToken = (getState) => {

    const primaryKey = getState().auth?.UserData?.adminDocterId || 0;
    const privateKey = getState().auth?.UserData?.privateKey || 0;
    const FIX_TOKEN = "HhcNMTQwMTMwMjMzNjUwWhcNMTUwMTMwMjMzNjUwWjCBjjElMCMGCgmSJomT8ixk";
    const preV = "jVgklxOHpE2IXNbnWDwb";
    const saltStr = "8B7072263C8A4b1dA1831BE47EB19366";
    const ivStr = "B5B399AA62949089BEEF86637B81773E";


    var nowdate = new Date();

    var r = arc4random() % 1000;

    var docOrUserId = primaryKey;
    var token = FIX_TOKEN + "_" + primaryKey;


    if (!docOrUserId) {
        return token;
    }
    if (!privateKey) {
        return token;
    }

    if (privateKey === FIX_TOKEN) {
        return token;
    }

    var t = parseInt(nowdate.getTime() / 1000, 10) % 1000;

    token = r + "_" + preV + "_" + primaryKey + "_" + t;

    token = token.trim();

    var iv = CryptoJS.enc.Hex.parse(ivStr);

    var salt = CryptoJS.enc.Hex.parse(saltStr);

    var key = CryptoJS.PBKDF2(privateKey, salt, { hasher: CryptoJS.algo.SHA256, keySize: 64 / 8, iterations: 999 });

    var encrypted = CryptoJS.AES.encrypt(token, key, { iv: iv });

    var newV = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

    newV = newV.replace(/\+/g, "-");
    newV = newV.replace(/\//g, "_");
    newV = newV.replace(/=/g, "~");

    return newV;
}


export const CustomLogger = (msg) => {

    console.log(`${moment(new Date()).format("hh:mm:ss a")} => ${msg} `)
}
